import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { debounce } from "lodash";
import moment from "moment";

import api from "services/api";

import { Access } from "common";
import { Page, Panel, Loading, Breadcrumbs, Pagination } from "components";
import { Filters, Document } from "./components";

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Profissionais EAD", to: "/professionals" },
      { name: "Documentos", to: "" },
    ],
    loading: true,
    documents: [],
    page: 1,
    total: 0,
    filter: {
      store: Access.lockedStore()
        ? Access.lockedStore(true)
        : { value: "", label: "Todos" },
      status: { value: "", label: "Todos" },
      search: { value: "" },
      state: { value: "", label: "Todos" },
      start_date: null,
      end_date: null,
    },
  };

  constructor(props) {
    super(props);

    this.handleDebounceSearch = debounce(this.loadData, 300);
  }

  loadData = async (page = 1) => {
    const { filter } = this.state;

    const filters = {
      store_id: filter.store.value !== "" ? filter.store.value : null,
      state_id: filter.state.value !== "" ? filter.state.value : null,
      search: filter.search.value !== "" ? filter.search.value : null,
      status: filter.status.value !== "" ? filter.status.value : null,
      start_date:
        filter.start_date !== null
          ? moment(filter.start_date).format("YYYY-MM-DD")
          : null,
      end_date:
        filter.end_date !== null
          ? moment(filter.end_date).format("YYYY-MM-DD")
          : null,
    };

    try {
      this.setState({ loading: true });
      const response = await api.get("/user/v2/document_approvals", {
        params: {
          ...filters,
          page,
          per: 20,
        },
      });
      const { data, meta } = response.data;

      this.setState({
        documents: data,
        page: meta.current_page,
        total: meta.total_count,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidUpdate(oldProps) {
    const { location } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      this.loadData(queryString.parse(location.search).page);
    }
  }

  componentDidMount() {
    const { location } = this.props;

    this.loadData(queryString.parse(location.search).page || 1);
    this.setState({ page: queryString.parse(location.search).page });
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;

    await this.setState({ filter: { ...filter, [name]: value } });
    this.loadData(1);
  };

  handleClean = async (e) => {
    e.preventDefault();

    await this.setState({
      filter: {
        store: Access.lockedStore()
          ? Access.lockedStore(true)
          : { value: "", label: "Todos" },
        status: { value: "", label: "Todos" },
        search: { value: "" },
        state: { value: "", label: "Todos" },
        start_date: null,
        end_date: null,
      },
    });
    this.loadData(1)
  };

  handleSearch = async (query) => {
    const { filter } = this.state;

    await this.setState({
      filter: {
        ...filter,
        search: {
          ...filter.search,
          value: query,
        },
      },
    });

    this.handleDebounceSearch(1)
  };

  render() {
    const { breadcrumbs, documents, total, page, loading, filter } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Documentos</Page.Title>

        <Filters
          filter={filter}
          onChange={this.handleChangeFilter}
          onChangeInput={this.handleSearch}
          onClean={this.handleClean}
        />

        <Panel className="panel-list">
          {!documents.length && loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>nome</th>
                    <th>CPF</th>
                    <th>documento</th>
                    <th>status</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!documents.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {documents.map((document) => (
                    <Document
                      document={document}
                      key={String(document.id)}
                      filters={filter}
                      onUpdate={() => this.loadData(page)}
                    />
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={page}
                total={total}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

export default List;
